import React from 'react'

const Banner = () => {
  return (
   <>
       <div className="orderhead">
           <div className="d-flex color-overlay justify-content-center align-items-center">

           </div>
       </div>
   </>

  )
}

export default Banner